import { } from '@fortawesome/pro-regular-svg-icons';
import {
  faArrowUpRightFromSquare
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useContext, useEffect } from 'react';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import VoxelLink from '../../components/voxel/Link/VoxelLink';
import Logo from '../../components/voxel/Logo/Logo';
import VoxelText from '../../components/voxel/Text/VoxelText';
import { useUpdateMetaTags } from '../../logic/otherUtilities/useUpdateMetaTags';
import { AuthenticationContext } from '../../logic/security/authentication/AuthenticationContext';
import GoogleLogo from './GoogleLogo';

export interface SelfSignUpPageProps {
  tokenVersion?: boolean;
}

const SelfSignUpPage: React.FC<SelfSignUpPageProps> = ({ tokenVersion }) => {
  const authenticationContext = useContext(AuthenticationContext);

  useEffect(() => {
    const devPrefix = window.location.href.includes('localhost') ? 'Dev | ' : '';
    if (tokenVersion) {
      document.title = `${devPrefix}Voxel – Sign in`;
    } else {
      document.title = `${devPrefix}Voxel – Sign up`;
    }
  }, []);

  useUpdateMetaTags([
    {
      name: 'description',
      content:
        'Sign up for your Voxel account here. Use your Google email for a seamless start and take your keyword game to the next level instantly!',
    },
  ]);

  return (
    <div className={`w-full h-screen bg-white flex flex-row relative`}>
      <div className="w-auto h-auto absolute top-8 left-8">
        <Logo size="xs" />
      </div>

      <div className="mt-64 mx-auto w-[464px] flex flex-col items-center gap-14">
        {tokenVersion && (
          <VoxelAlert title="Sign in first">
            Before you accept the invitation you need to sign in. If you don't have an account we'll
            set you up.
          </VoxelAlert>
        )}
        <VoxelText
          userSelectClass="select-none"
          className="mx-auto w-fit text-[30px] whitespace-pre-line text-voxel-blue-400 font-semibold "
        >
          Voxel requires that you use a{' '}
          <span className="font-black text-voxel-blue-200">google account </span>
          to register and log in
        </VoxelText>
        <div className="w-full flex flex-col gap-16">
          <VoxelButton
            shape="square"
            onClick={() => {
              authenticationContext.signIn();
            }}
            title={
              <div className="flex flex-row items-center justify-center gap-0.5">
                <GoogleLogo />
                <VoxelText variant="bread-semibold">
                  {tokenVersion ? 'Sign in with Google' : 'Register with Google'}
                </VoxelText>
              </div>
            }
            size="xl"
            color="transparent"
            className=" w-[464px] mx-auto border-2 border-voxel-blue"
          />
          <VoxelText color={'medium'} className="w-full leading-6">
            If you don't have a google account,
            <VoxelLink
              className={'font-bold text-voxel-gray-600'}
              href="https://accounts.google.com/signup/v2/webcreateaccount?gmb=exp&biz=true&flowName=GlifWebSignIn&flowEntry=SignUp"
              openInNewTab
            >
              {' '}
              sign up to Google
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="px-1" />
            </VoxelLink>
            and select <span className="italic font-semibold">use an existing email</span>.
          </VoxelText>
        </div>
      </div>
    </div>
  );
};

export default SelfSignUpPage;
